import { createSlice } from '@reduxjs/toolkit';
import { deleteAccountThunk, getUserThunk, updateUserProfileThunk } from '../thunk/user.thunk';

const initialState = {
  user: {
    result: null,
    isLoading: false,
    error: null,
  },
  updateUser: {
    isLoading: false,
    error: null,
  },
  deleteAccount: {
    isLoading: false,
    error: null,
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserThunk.pending, (state) => {
        state.user = {
          isLoading: true,
          result: null,
          error: null,
        };
      })
      .addCase(getUserThunk.fulfilled, (state, { payload }) => {
        state.user = {
          ...state.user,
          isLoading: false,
          result: payload,
        };
      })
      .addCase(getUserThunk.rejected, (state, { payload }) => {
        state.user = {
          ...state.user,
          isLoading: false,
          error: payload,
        };
      });

    builder
      .addCase(updateUserProfileThunk.pending, (state) => {
        state.updateUser = {
          isLoading: true,
          error: null,
        };
      })
      .addCase(updateUserProfileThunk.fulfilled, (state, { payload }) => {
        state.updateUser = {
          isLoading: false,
          error: null,
        };

        if (payload) {
          state.user = {
            ...state.user,
            result: payload,
          };
        }
      })
      .addCase(updateUserProfileThunk.rejected, (state, { payload }) => {
        state.updateUser = {
          isLoading: false,
          error: payload,
        };
      });

    builder
      .addCase(deleteAccountThunk.pending, (state) => {
        state.deleteAccount = {
          isLoading: true,
          error: null,
        };
      })
      .addCase(deleteAccountThunk.fulfilled, (state) => {
        state.deleteAccount = {
          isLoading: false,
          error: null,
        };
        state.user = {
          ...state.user,
          result: null,
        };
      })
      .addCase(deleteAccountThunk.rejected, (state, { payload }) => {
        state.deleteAccount = {
          isLoading: false,
          error: payload,
        };
      });
  },
});
